/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
var o;!function(o){o[o.Color=0]="Color",o[o.Alpha=1]="Alpha",o[o.FrontFace=2]="FrontFace",o[o.NONE=3]="NONE",o[o.COUNT=4]="COUNT"}(o||(o={}));export{o as TransparencyPassType};
